import TabLayout from "./TabLayout";

export default TabLayout;